import { render } from "./NoneTicket.vue?vue&type=template&id=2488aedf"
import script from "./NoneTicket.vue?vue&type=script&lang=js"
export * from "./NoneTicket.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__